module.exports = "/static/assets/2bef63c6b6d3a827d702f23322bb0dea.png";